// extracted by mini-css-extract-plugin
export default {"headerSolicitudes":"TablaProducto_headerSolicitudes__sBOhl","text_danger":"TablaProducto_text_danger__yxgxK","text_success":"TablaProducto_text_success__J-vic"};